export const Lx = {
    Login: {
        LOGGING_IN: 'logging_in',
        AUTHENTICATION_CODE_CANT_BE_USED: 'authentication_code_can_not_be_used',
        AUTHENTICATION_ISNT_DONE: 'authentication_is_not_done',
        LOGGED_OUT: 'logged_out',
        LOGOUT: 'log_out'
    },
    General: {
        TYPES: 'types',
        PROJECT_TYPES: 'project_types',
        TAG_TYPES: 'tags_types',
        SHIFT_TYPES: 'shift_types',
        ABSENCES_TYPES: 'absences_types',
        ROLES: 'roles',
        EMPLOYEES: 'employees',
        CLIENTS: 'clients',
        PROJECTS: 'projects',
        SETTINGS: 'settings',
        PREFERENCES: 'preferences',
        NOTIFICATIONS: 'notifications',
        INTEGRATIONS: 'integrations',
        EARLYACCESS: 'earlyAccess',
        WORKCALENDAR: 'workCalendar',
        BILLING: 'billing',
        PAYMENTS: 'payments',
        PROFILE: 'profile',
        SCHEDULE: 'schedule',
        CREATE_NEW: 'create_new',
        DELETE: 'delete',
        ME: 'me',
        USER: 'user',
        EMAIL: 'email',
        PHONENUMBER: 'phonenumber',
        SUBSCRIPTION: 'subscription',
        WEB_PAGE: 'timinator_page',
        CALENDAR: 'calendar',
        WORK_CALENDAR: 'work_calendar',
        WORKING_ON_IT: 'we_re_working_on_it',
        TRY_AGAIN: 'try_again',
        UNKNOWN_ERROR: 'unknown_error',
        COLLAPSE: 'collapse',
        COLLAPSE_ALL: 'collapse_all',
        ITEM_OF_ITEM_FORMAT: 'item_of_item',
        SHIFT: 'shift',
        ABSENCE: 'absence',
        TYPE: 'type',
        STATUS: 'status',
        HIDE_MENU: 'hide_menu',
        SHIFT_TYPE: 'shift_type',
        EMPLOYEE: 'employee',
        PROJECT: 'project',
        NAME_PLACEHOLDER: 'name_placeholder',
        WRITE_SOMETHING: 'write_something',
        EXPAND_ALL: 'expand_all',
        SHOW_SMTH: 'show_smth',
        HIDE_SMTH: 'hide_smth',
        REPORT: 'report',
        CREATE: 'create',
        EDIT: 'edit',
        CURRENT_MONTH: 'currentMonth',
        NEXT_MONTH: 'nextMonth',
        PREVIOUS_MONTH: 'previousMonth',
        THIS_WEEK: 'thisWeek',
        LAST_WEEK: 'lastWeek',
        CUSTOM: 'custom',
        PROJECT_TYPE: 'project_type',
        TAG_TYPE: 'tag_type',
        ABSENCE_TYPE: 'absence_type',
        ROLE: 'role',
        CLIENT: 'client',
        FILTER: 'filter',
        RESET_FILTER: 'reset_filter',
        APPLY_FILTER: 'apply_filter',
        CLEAR_FILTERS: 'clear_filters',
        CLEAR: 'clear',
        FAVORITE_FILTERS: 'favorite_filters',
        SAVE_AS_FAVORITE: 'save_as_favorite',
        FAVORITE_NAME_PLACEHOLDER: 'favorite_name_placeholder',
        DELETE_FAVORITE_CONFIRM: 'delete_favorite_confirm',
        NO_FAVORITE_FILTERS: 'no_favorite_filters',
        APPLY_AND_GO_BACK: 'apply_and_go_back',
        FAVORITE_FILTERS_HINT: 'favorite_filters_hint',
        ADD_ENTITIES: 'add_entities',
        PRESETS: 'Presets',
        START_TYPING: 'start_typing',
        FROM: 'from',
        TO: 'to',
        VACATION: 'vacation',
        CHOOSE_EMPLOYEE: 'choose_employee',
        PREVIOUS_QUARTER: 'previousQuarter',
        CURRENT_QUARTER: 'currentQuarter',
        DATE: 'date',
        COST: 'cost',
        PREVIOUS_YEAR: 'previousYear',
        CURRENT_YEAR: 'currentYear',
        NONE: 'none',
        USE_FOR_VACATION: 'use_for_vacation',
        USE_FOR_WILL_WORK: 'use_for_will_work',
        LIMIT_TO_PLANNED_HOURS: 'limit_to_planned_hours',
        SAVE: 'save',
        OPTIONAL: 'optional',
        APPLY: 'apply',
        ALL_STATUSES: 'all_statuses',
        ACTIVE: 'active',
        SUSPENDED: 'suspended',
        NAME: 'name',
        DEFAULT: 'default',
        CANCEL: 'cancel',
        CLOSE: 'close',
        NOT_SUPPORTED: 'not_supported',
        PROJECT_MANAGER: 'project_manager',
        TAGS: 'tags',
        ROLE_FOR_NOTIFICATION: 'role_for_notification',
        NOTE: 'note',
        WORKSPACE: 'workspace',
        NOT_AVAILABLE: 'not_available',
        VALUE: 'value'
    },
    TimeTrackingImport: {
        TITLE: 'time_tracking_import_title',
        MAPPED_TARGET_WILL_BE_CREATED: 'time_tracking_import_mapped_target_will_be_created',
        MAPPING_NOT_APPLIED: 'time_tracking_import_mapping_not_applied',
        FAILED_DEFAULT: 'time_tracking_import_failed_default',
        BLOCKED_NO_FILE: 'time_tracking_import_blocked_no_file',
        BLOCKED_NO_PREVIEW: 'time_tracking_import_blocked_no_preview',
        BLOCKED_NO_ROWS: 'time_tracking_import_blocked_no_rows',
        BLOCKED_DIAGNOSTICS: 'time_tracking_import_blocked_diagnostics',
        BLOCKED_TITLE: 'time_tracking_import_blocked_title',
        SKIP_ERRORS_TITLE: 'time_tracking_import_skip_errors_title',
        SKIP_ERRORS_DESCRIPTION: 'time_tracking_import_skip_errors_description',
        SKIP_ERRORS_LABEL: 'time_tracking_import_skip_errors_label',
        UNSUPPORTED_FILE: 'time_tracking_import_unsupported_file',
        NO_COLUMNS_DETECTED: 'time_tracking_import_no_columns_detected',
        UNABLE_TO_READ_FILE: 'time_tracking_import_unable_to_read_file',
        FILL_REQUIRED_MAPPINGS: 'time_tracking_import_fill_required_mappings',
        IMPORTED_ROWS: 'time_tracking_import_imported_rows',
        FAILED_WITH_COUNTS: 'time_tracking_import_failed_with_counts',
        FAILED_TITLE: 'time_tracking_import_failed_title',
        RETURN_TO_TIMESHEET: 'time_tracking_import_return_to_timesheet',
        CHOOSE_FILE: 'time_tracking_import_choose_file',
        DOWNLOAD_TEMPLATE: 'time_tracking_import_download_template',
        DOWNLOAD_TEMPLATE_HINT: 'time_tracking_import_download_template_hint',
        DOWNLOAD_TEMPLATE_FAILED: 'time_tracking_import_download_template_failed',
        DATA_MAPPING: 'time_tracking_import_data_mapping',
        CONTINUE: 'time_tracking_import_continue',
        IMPORT_ROWS: 'time_tracking_import_import_rows',
        EDIT_MAPPING: 'time_tracking_import_edit_mapping',
        BACK: 'time_tracking_import_back',
        DATA_MAPPING_ROWS_COUNT: 'time_tracking_import_data_mapping_rows_count',
        DATA_MAPPING_DESCRIPTION: 'time_tracking_import_data_mapping_description',
        DATA_MAPPING_NO_UNRESOLVED: 'time_tracking_import_data_mapping_no_unresolved',
        DATA_MAPPING_USE_EXISTING: 'time_tracking_import_data_mapping_use_existing',
        DATA_MAPPING_CREATE_NEW: 'time_tracking_import_data_mapping_create_new',
        DATA_MAPPING_SELECT_REPLACEMENT: 'time_tracking_import_data_mapping_select_replacement',
        DATA_MAPPING_NEW_TARGET_NAME: 'time_tracking_import_data_mapping_new_target_name',
        DATA_MAPPING_SOURCE_VALUE_COLUMN: 'time_tracking_import_data_mapping_source_value_column',
        DATA_MAPPING_ROWS_COLUMN: 'time_tracking_import_data_mapping_rows_column',
        DATA_MAPPING_ACTION_COLUMN: 'time_tracking_import_data_mapping_action_column',
        DATA_MAPPING_MAPPING_COLUMN: 'time_tracking_import_data_mapping_mapping_column',
        DATA_MAPPING_SOURCE_VARIANTS: 'time_tracking_import_data_mapping_source_variants',
        PREVIEW_GROUP_ROWS: 'time_tracking_import_preview_group_rows',
        PREVIEW_GROUP_HOURS: 'time_tracking_import_preview_group_hours',
        PREVIEW_GROUP_READY: 'time_tracking_import_preview_group_ready',
        PREVIEW_GROUP_WARNINGS: 'time_tracking_import_preview_group_warnings',
        PREVIEW_GROUP_ERRORS: 'time_tracking_import_preview_group_errors',
        PREVIEW_NEW_ENTITY_TAG: 'time_tracking_import_preview_new_entity_tag',
        PREVIEW_STATUS_READY: 'time_tracking_import_preview_status_ready',
        PREVIEW_STATUS_WARNING: 'time_tracking_import_preview_status_warning',
        PREVIEW_STATUS_ERROR: 'time_tracking_import_preview_status_error',
        PREVIEW_NO_ISSUES: 'time_tracking_import_preview_no_issues',
        PREVIEW_COLUMN_STATUS: 'time_tracking_import_preview_column_status',
        PREVIEW_COLUMN_DATE: 'time_tracking_import_preview_column_date',
        PREVIEW_COLUMN_HOURS: 'time_tracking_import_preview_column_hours',
        PREVIEW_COLUMN_PROJECT_ABSENCE: 'time_tracking_import_preview_column_project_absence',
        PREVIEW_COLUMN_TYPE: 'time_tracking_import_preview_column_type',
        PREVIEW_COLUMN_COMMENT: 'time_tracking_import_preview_column_comment',
        PREVIEW_COLUMN_TAGS: 'time_tracking_import_preview_column_tags',
        PREVIEW_COLUMN_ISSUES: 'time_tracking_import_preview_column_issues',
        PREVIEW_COLLAPSE_ALL: 'time_tracking_import_preview_collapse_all',
        PREVIEW_EXPAND_ALL: 'time_tracking_import_preview_expand_all',
        PREVIEW_STAT_TOTAL: 'time_tracking_import_preview_stat_total',
        PREVIEW_STAT_READY: 'time_tracking_import_preview_stat_ready',
        PREVIEW_STAT_WARNINGS: 'time_tracking_import_preview_stat_warnings',
        PREVIEW_STAT_ERRORS: 'time_tracking_import_preview_stat_errors',
        PREVIEW_STAT_UNRESOLVED: 'time_tracking_import_preview_stat_unresolved',
        PREVIEW_TITLE: 'time_tracking_import_preview_title',
        PREVIEW_DESCRIPTION: 'time_tracking_import_preview_description',
        PREVIEW_UNRESOLVED_VALUES: 'time_tracking_import_preview_unresolved_values',
        PREVIEW_UNRESOLVED_ROWS: 'time_tracking_import_preview_unresolved_rows',
        MANUAL_ROW_ADD: 'time_tracking_import_manual_row_add',
        MANUAL_ROW_TAG: 'time_tracking_import_manual_row_tag',
        MANUAL_ROW_EDITED_TAG: 'time_tracking_import_manual_row_edited_tag',
        PREVIEW_COLUMN_OVERTIME: 'time_tracking_import_preview_column_overtime',
        REMOVED_ROWS_NOTICE: 'time_tracking_import_removed_rows_notice',
        REMOVED_ROWS_RESTORE: 'time_tracking_import_removed_rows_restore',
        MANUAL_ROW_EDIT: 'time_tracking_import_manual_row_edit',
        MANUAL_ROW_REMOVE: 'time_tracking_import_manual_row_remove',
        MANUAL_ROW_PREVIEW_FAILED: 'time_tracking_import_manual_row_preview_failed',
        MANUAL_ROW_DIALOG_ADD_TITLE: 'time_tracking_import_manual_row_dialog_add_title',
        MANUAL_ROW_DIALOG_EDIT_TITLE: 'time_tracking_import_manual_row_dialog_edit_title',
        MANUAL_ROW_DIALOG_DESCRIPTION: 'time_tracking_import_manual_row_dialog_description',
        MANUAL_ROW_EMPLOYEE_HINT: 'time_tracking_import_manual_row_employee_hint',
        MANUAL_ROW_DATE_OUT_OF_RANGE: 'time_tracking_import_manual_row_date_out_of_range',
        MAPPING_TITLE: 'time_tracking_import_mapping_title',
        MAPPING_DESCRIPTION: 'time_tracking_import_mapping_description',
        MAPPING_NOT_SELECTED: 'time_tracking_import_mapping_not_selected',
        MAPPING_NO_DETECTED_COLUMNS: 'time_tracking_import_mapping_no_detected_columns',
        MAPPING_EMPLOYEE_COLUMN: 'time_tracking_import_mapping_employee_column',
        MAPPING_EMPLOYEE_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_employee_column_description',
        MAPPING_EMPLOYEE_MODE_COLUMN: 'time_tracking_import_mapping_employee_mode_column',
        MAPPING_EMPLOYEE_MODE_MANUAL: 'time_tracking_import_mapping_employee_mode_manual',
        MAPPING_EMPLOYEE_NAME_PLACEHOLDER: 'time_tracking_import_mapping_employee_name_placeholder',
        MAPPING_DATE_COLUMN: 'time_tracking_import_mapping_date_column',
        MAPPING_DATE_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_date_column_description',
        MAPPING_HOURS_COLUMN: 'time_tracking_import_mapping_hours_column',
        MAPPING_HOURS_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_hours_column_description',
        MAPPING_PROJECT_ABSENCE_COLUMN: 'time_tracking_import_mapping_project_absence_column',
        MAPPING_PROJECT_ABSENCE_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_project_absence_column_description',
        MAPPING_TYPE_COLUMN: 'time_tracking_import_mapping_type_column',
        MAPPING_TYPE_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_type_column_description',
        MAPPING_COMMENT_COLUMN: 'time_tracking_import_mapping_comment_column',
        MAPPING_COMMENT_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_comment_column_description',
        MAPPING_TAGS_COLUMN: 'time_tracking_import_mapping_tags_column',
        MAPPING_TAGS_COLUMN_DESCRIPTION: 'time_tracking_import_mapping_tags_column_description'
    },
    Theme: {
        DARK_MODE: 'dark_mode',
        LIGHT_MODE: 'light_mode'
    },
    Form: {
        REQUIRED: 'required',
        MAX_LENGTH_ERROR: 'max_length_error',
        PHONE_NUMBER_ISNT_VALID: 'phone_number_is_not_valid',
        EMPTY_FIELD_ABILITY: 'empty_field_ability',
        NAME_REQUIRED_FORMAT: 'form_name_required_format',
        N_REQUIRED_FORMAT: 'form_n_required_format'
    },
    Payment: {
        CURRENT_PAYMENTMETHOD: 'currentPaymentMethod',
        PAYMENTMETHOD_SETUP: 'paymentMethod_setup',
        NO_PAYMENTMETHOD_DISP: 'you_have_no_payment_method_added',
        NO_PAYMENTMETHOD_DESC: 'you_have_no_payment_method_added_desc',
        NEW_PAYMENTMETHOD: 'add_payment_method',
    },
    Subscription: {
        TRIAL: 'timinator_trial',
        CONNECTED: 'timinator_connected',
        SUBSCRIPTION_END_FORMAT: 'your_sub_active_unt',
        COST_PER_MONTH_FORMAT: 'per_human_per_month',
        TRY_TRIAL: 'try_timinator',
        NEXT_PAYMENT: 'next_payment',
        FEATURES: 'get_list_of_features',
        TIMINATOR_FREE: 'timinator_free',
        TIMINATOR_PAID: 'timinator_paid'
    },
    Calendar: {
        WORK_DAY: 'standard_work_day',
        WEEKEND_OR_DAY_OFF: 'weekend_or_day_off',
        CUSTOM_DAY: 'customized',
        WORK_HOURS: 'work_hours',
        DAY_TYPE: 'day_type',
        EDIT_DATE_SETTINGS: 'edit_date_settings',
        YEAR: 'year',
        NAME: 'calendarName',
        REGION: 'region',
        WORKHOURS_IN_DAY: 'workHours_in_day',
        WORKHOURS_IN_SHORT_DAY: 'workHours_in_shortDay',
        CREATE_WORK_CALENDAR: 'create_work_calendar',
        EDIT_WORK_CALENDAR: 'edit_work_calendar',
        EDIT_CALENDAR_DESC: 'edit_work_calendar_info',
        DELETE_CALENDAR_DISP: 'delete_work_calendar',
        DELETE_CALENDAR_DESC: 'delete_work_calendar_info',
        DELETE_CALENDAR_ROOT_WARNING: 'delete_work_calendar_root_warning',
        WORKING_DAY: 'working_day',
        SHORT_DAY: 'short_day',
        DAY_OFF: 'day_off',
        PRIMARY: 'calendar_primary',
        CHOOSE_DAY_TO_EDIT: 'choose_day_on_month_to_edit'
    },
    Integration: {
        CONNECT: 'integration_connect',
        DISCONNECT: 'integration_disconnect',
        CONFIGURE: 'integration_configure',
        NOT_CONNECTED: 'integration_not_connected',
        NONE_AVAILABLE: 'integration_none_available',
        DISCONNECT_TITLE_FORMAT: 'integration_disconnect_title',
        DISCONNECT_DISP: 'integration_disconnect_info',
        DISCONNECT_DESC_FORMAT: 'integration_disconnect_desc',
        DISCONNECT_COMPLETE_FORMAT: 'integration_disconnect_done',
        TITLE_FORMAT: 'integration_name',
        Zoho: {
            LINK: 'zoho_integration_link',
            DESC: 'zoho_integration_desc',
            ORGANIZATIONS: 'zoho_organizations',
            EMPLOYEE_NOTIFY: 'zoho_employees_for_notify',
            CREATED: 'zoho_created_successfully',
            NOT_FOUND: 'zoho_request_not_found'
        },
        WAITING_CONFIGURATION: 'integration_wating_for_configuration',
        SELECT_EMPLOYEES: 'select_one_more_employees',
        SELECT_PROJECTS: 'select_one_more_projects',
        PRESS_BUTTON_TO_BACK: 'press_da_button_kronk'
    },
    Schedule: {
        TYPE_DAY: 'schedule_type_day',
        TYPE_WEEK: 'schedule_type_week',
        TYPE_MONTH: 'schedule_type_month',
        TIMESHIFT_DATE: 'schedule_timeshift_date',
        TIMESHIFT_TARGET: 'schedule_timeshift_target',
        TIMESHIFT_TYPE: 'schedule_timeshift_type',
        TIMESHIFT_NOTE: 'schedule_timeshift_note',
        TIMESHIFT_INTERNAL_NOTE: 'schedule_timeshift_internal_note',
        TIMESHIFT_HOURS: 'schedule_timeshift_hours',
        APPROVE_FORMAT: 'schedule_timeshift_approve',
        APPROVE_ALL_FORMAT: 'schedule_timeshift_approve_all',
        APPROVE_ALL_SHIFT_FORMAT: 'schedule_timeshift_approve_shift',
        NOTHING_TO_APPROVE: 'schedule_nothing_to_approve',
        BILL_FORMAT: 'schedule_timeshift_bill',
        BILL_SHIFT_FORMAT: 'schedule_timeshift_bill_shift',
        BILL_ALL_FORMAT: 'schedule_timeshift_bill_all',
        NOTHING_TO_BILL: 'schedule_nothing_to_bill',
        DISAPPROVE_FORMAT_ALL: 'schedule_timeshift_disapprove_all',
        DISAPPROVE_SHIFT_FORMAT: 'schedule_timeshift_disapprove_shift',
        DISAPPROVE_ALL: 'schedule_timeshift_disapprove',
        DISAPPROVE_FORMAT: 'schedule_timeshift_disapprove_format',
        CANCEL_BILL_FORMAT: 'schedule_timeshift_cancel_bill_all',
        CANCEL_BILL_ALL: 'schedule_timeshift_cancel_bill',
        TOTAL_HOURS: 'schedule_total_hours',
        APPROVED_HOURS: 'schedule_approved_hours',
        BILLABLE_HOURS: 'schedule_billable_hours',
        REGULAR_HOURS: 'schedule_regular_hours',
        EMPLOYEE_VIEW: 'schedule_employee_view',
        PROJECT_VIEW: 'schedule_project_view',
        FILTER_BY_EMPLOYEES: 'schedule_filter_by_employees',
        FILTER_BY_PROJECTS: 'schedule_filter_by_projects',
        FILTER_BY_TYPES: 'schedule_filter_by_types',
        CREATE_REPORT: 'schedule_create_report',
        CREATING_REPORT: 'schedule_creating_report',
        CREATE_NEW_TIMESHIFT_SHIFT_TO_THIS_DAY: 'schedule_create_timeshift_shift_to_this_day',
        CREATE_NEW_TIMESHIFT_SHIFT: 'schedule_create_timeshift_shift',
        CREATE_NEW_TIMESHIFT_ABSENCE: 'schedule_create_timeshift_absence',
        EDIT_TIMESHIFT_SHIFT: 'schedule_edit_timeshift_shift',
        COPY_TIMESHIFT_SHIFT: 'schedule_copy_timeshift_shift',
        COPY_TIMESHIFT_ABSENCE: 'schedule_copy_timeshift_absence',
        DELETE_TIMESHIFT_ITEM: 'schedule_delete_timeshift_item',
        DELETE_TIMESHIFT_SHIFT: 'schedule_delete_timeshift_shift',
        IS_OVERTIME: 'schedule_is_overtime',
        ADD_TO_TIME_BANK: 'schedule_add_to_time_bank',
        USE_FROM_TIME_BANK: 'schedule_use_from_time_bank',
        OVERTIME_HOURS: 'schedule_overtime_hours',
        PLANNED_HOURS: 'schedule_planned_hours',
        WORKED_HOURS: 'schedule_worked_hours',
        ABSENCE_HOURS: 'schedule_absence_hours',
        TIME_BANK_BALANCE: 'schedule_time_bank_balance',
        DELETE_TIMESHIFT_ABSENCE: 'schedule_delete_timeshift_absence',
        EDIT_TIMESHIFT_ABSENCE: 'schedule_edit_timeshift_absence',
        WORKED_HOURS_ABBREVIATION: 'schedule_worked_hours_abbreviation',
        PLANNED_HOURS_ABBREVIATION: 'schedule_planned_hours_abbreviation',
        ABSENCE_HOURS_ABBREVIATION: 'schedule_absence_hours_abbreviation',
        OVERTIME_HOURS_ABBREVIATION: 'schedule_overtime_hours_abbreviation',
        TIME_BANK_BALANCE_ABBREVIATION: 'schedule_time_bank_balance_abbreviation',
    },
    Employee: {
        FIRST_NAME: 'employee_first_name',
        LAST_NAME: 'employee_last_name',
        POSITION: 'employee_position',
        ADMIN: 'employee_admin',
        CREATE_EMPLOYEE: 'create_employee',
        EDIT_EMPLOYEE: 'edit_employee',
        NO_EMPLOYEES: 'no_employees',
        CREATE_AND_USE_EMPLOYEE: 'create_and_use_employee',
        MAIN_INFORMATION: 'employee_main_information',
        CONTACT_INFORMATION: 'employee_contact_information',
        ASSIGNMENTS: 'employee_assignments',
        WILL_WORK_BALANCE: 'employee_will_work_balance'
    },
    Client: {
        CREATE_CLIENT: 'create_client',
        EDIT_CLIENT: 'edit_client',
        CONTACT_PERSON: 'client_contact_person',
        SITE: 'client_site',
        NOTE: 'client_note',
        NO_CLIENTS: 'no_clients',
        CREATE_AND_USE_CLIENT: 'create_and_use_client',
        NAME_TAKEN: 'client_name_taken',
        DELETE_CLIENT: 'delete_client',
        DELETE_CLIENT_MESSAGE: 'delete_client_message'
    },
    Report: {
        SHOW_ABSENCES: 'show_absences',
        ALL_DAYS: 'report_all_days',
        ONLY_INCORRECT_DAYS: 'report_only_incorrect_days'
    },
    Vacation: {
        CREATE_NEW_VACATION: 'vacation_create_new_vacation',
        MESSAGE: 'vacation_message',
        NOTIFY_ABOUT_START: 'vacation_notify_about_start',
        NOTIFY_IN_ADVANCE: 'vacation_notify_in_advance',
        STATE: 'vacation_state',
        STATE_WAIT_APPROVE: 'vacation_state_wait_approve',
        STATE_APPROVED: 'vacation_state_approved',
        STATE_APPROVED_BY_YOU: 'vacation_state_approved_by_you',
        NOTIFY_IN_ADVANCE_DISABLED: 'vacation_notify_in_advance_disabled',
        NOTIFY_IN_ADVANCE_ONE_DAY: 'vacation_notify_in_advance_one_day',
        NOTIFY_IN_ADVANCE_TWO_DAYS: 'vacation_notify_in_advance_two_days',
        NOTIFY_IN_ADVANCE_THREE_DAYS: 'vacation_notify_in_advance_three_days',
        NOTIFY_IN_ADVANCE_FOUR_DAYS: 'vacation_notify_in_advance_four_days',
        NOTIFY_IN_ADVANCE_FIVE_DAYS: 'vacation_notify_in_advance_five_days',
        NOTIFY_ABOUT_START_TEAMMATES_ONLY: 'vacation_notify_about_start_teammates_only',     
        NOTIFY_ABOUT_START_ALL_EMPLOYEES: 'vacation_notify_about_start_all_employees',  
        INVALID_EMPLOYEE_ID: 'vacation_invalid_employee_id', 
        INVALID_DATE_FROM: 'vacation_invalid_date_from', 
        INVALID_DATE_TO: 'vacation_invalid_date_to',
        APPROVE_CONFIRM_MESSAGE: 'vacation_approve_confirm_message',
        APPROVE_FORCE_CONFIRM_MESSAGE: 'vacation_approve_force_confirm_message',
        APPROVE: 'vacation_approve',
        IGNORE_OTHER_APPROVERS: 'vacation_ignore_other_approvers',
        APPROVER_APPROVED: 'vacation_approver_approved',
        APPROVER_NOT_APPROVED: 'vacation_approver_not_approved',
        CANCEL_CONFIRM_MESSAGE: 'vacation_cancel_confirm_message',
        CANCEL_TITLE: 'vacation_cancel_title',
        DECLINE: 'vacation_decline',
        DECLINE_CONFIRM_MESSAGE: 'vacation_decline_confirm_message',
        DECLINE_TITLE: 'vacation_decline_title',
        APPROVE_TITLE: 'vacation_approve_title'
    },
    Type: {
        EDIT_PROJECT_TYPE: 'edit_project_type',
        CREATE_PROJECT_TYPE: 'create_project_type',
        NO_PROJECT_TYPES: 'no_project_types',
        CREATE_AND_USE_PROJECT_TYPE: 'create_and_use_project_type',
        DELETE_PROJECT_TYPE: 'delete_project_type',
        DELETE_PROJECT_TYPE_MESSAGE: 'delete_project_type_message',
        EDIT_ABSENCE_TYPE: 'edit_absence_type',
        CREATE_ABSENCE_TYPE: 'create_absence_type',
        NO_ABSENCE_TYPES: 'no_absence_types',
        CREATE_AND_USE_ABSENCE_TYPE: 'create_and_use_absence_type',
        DELETE_ABSENCE_TYPE: 'delete_absence_type',
        DELETE_ABSENCE_TYPE_MESSAGE: 'delete_absence_type_message',
        EDIT_SHIFT_TYPE: 'edit_shift_type',
        CREATE_SHIFT_TYPE: 'create_shift_type',
        NO_SHIFT_TYPES: 'no_shift_types',
        CREATE_AND_USE_SHIFT_TYPE: 'create_and_use_shift_type',
        DELETE_SHIFT_TYPE: 'delete_shift_type',
        DELETE_SHIFT_TYPE_MESSAGE: 'delete_shift_type_message',
        CREATE_TAG_TYPE: 'create_tag_type',
        NO_TAG_TYPES: 'no_tag_types',
        CREATE_AND_USE_TAG_TYPE: 'create_and_use_tag_type',
        DELETE_TAG_TYPE: 'delete_tag_type',
        DELETE_TAG_TYPE_MESSAGE: 'delete_tag_type_message',
    },
    Cost: {
        AMOUNT: 'cost_amount',
        NOTE: 'cost_note',
        FILES: 'cost_files',
        ADD: 'cost_add',
        DELETE: 'cost_delete',
        EDIT: 'cost_edit',
        UPLOAD_FILES: 'cost_upload_files',
        DELETE_COST: 'delete_cost',
        DELETE_COST_INFO: 'delete_cost_info',
        UPLOAD_FILES_HINT: 'cost_upload_files_hint',
        INVALID_FILES_COUNT: 'cost_invalid_files_count', 
        INVALID_FILES_EXTENSION: 'cost_invalid_files_extension'
    },
    TimeBank: {
        BALANCE: 'timebank_balance',
        ADDED: 'timebank_added',
        USED: 'timebank_used',
        OPENING_BALANCE: 'timebank_opening_balance',
        PERIOD_BALANCE: 'timebank_period_balance',
        CURRENT_BALANCE: 'timebank_current_balance',
        HOURS: 'timebank_hours',
        SOURCE: 'timebank_source',
    },
    Role: {
        EDIT_ROLE: 'edit_role',
        CREATE_ROLE: 'create_role',
        NO_ROLES: 'no_roles',
        CREATE_AND_USE_ROLE: 'create_and_use_role',
        DELETE_ROLE: 'delete_role',
        DELETE_ROLE_MESSAGE: 'delete_role_message',
        MAIN_INFORMATION: 'role_main_information',
        PERMISSIONS: 'role_permissions'
    },
    Project: {
        CREATE_PROJECT: 'create_project',
        EDIT_PROJECT: 'edit_project',
        DELETE_PROJECT: 'delete_project',
        DELETE_PROJECT_MESSAGE: 'delete_project_message',
        NO_PROJECTS: 'no_projects',
        CREATE_AND_USE_PROJECT: 'create_and_use_project',
        NAME_TAKEN: 'project_name_taken',
    },
    Settings: {
        EARLY_ACCESS: {
            TITLE: 'settings_early_access_title',
            ACTIVE: 'settings_early_access_active',
            NOT_ENABLED: 'settings_early_access_not_enabled',
            ENABLE: 'settings_early_access_enable',
            DISABLE: 'settings_early_access_disable',
            DESCRIPTION_PART1: 'settings_early_access_description_part1',
            DESCRIPTION_PART2: 'settings_early_access_description_part2',
            DESCRIPTION_PART3: 'settings_early_access_description_part3',
        },
        NOTIFICATIONS: {
            CHANNEL_LABEL: 'settings_notifications_channel_label',
            MONTH_END_TOGGLE_LABEL: 'settings_notifications_month_end_toggle_label',
        },
        EDIT_PROJECT: 'edit_project',
        DELETE_PROJECT: 'delete_project',
        DELETE_PROJECT_MESSAGE: 'delete_project_message',
        NO_PROJECTS: 'no_projects',
        CREATE_AND_USE_PROJECT: 'create_and_use_project',
    }
}
